import { render } from "./complete-the-look.vue?vue&type=template&id=4075574a"
import script from "./complete-the-look.vue?vue&type=script&lang=js"
export * from "./complete-the-look.vue?vue&type=script&lang=js"

import "./complete-the-look.vue?vue&type=style&index=0&id=4075574a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__